import API from "@aws-amplify/api";
import { getCurrentJwt } from "../../../../util/jwt/decryptToken"
import CryptoJS from 'crypto-js'

export async function fetchFavoriteFilter() {

  let user_name = JSON.parse(
    CryptoJS.AES.decrypt(
      localStorage.getItem("email"),
      process.env.REACT_APP_PASS
    ).toString(CryptoJS.enc.Utf8)
  )
  let client_name = JSON.parse(
    CryptoJS.AES.decrypt(
      localStorage.getItem("conceptName"),
      process.env.REACT_APP_PASS
    ).toString(CryptoJS.enc.Utf8)
  )
  const options = {
    headers: {
      Authorization: getCurrentJwt()
    },
    body: {},
  };

  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await API.get(process.env.REACT_APP_AMPLIFY_API, `/audience-builder/tag-favorite-filters?client_name=${client_name}&user_name=${user_name}`, options).then(data => data)
      return res
    }
    catch (e) {
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}


export async function updateFavoriteFilter(data) {
  const options = {
    headers: {
      Authorization: getCurrentJwt()
    },
    body: {
      data:data,
      user_name: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("email"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
      client_name: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("conceptName"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      )
    },
  };

  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await API.post(process.env.REACT_APP_AMPLIFY_API, '/audience-builder/tag-favorite-filters', options).then(data => data)
      return res
    }
    catch (e) {
      console.log(e)
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataFetches/fetchFavoriteFilters.js